import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListItemTitleContent from './ListItemTitleContent';
import LocaleSwitcher from './LocaleSwitcher';
import ListItemWarningIcon from './ListItemWarningIcon';

const ListItemTitle = ({itemCode, itemService}) => {
    const { i18n } = useTranslation();
    const [productLocale, setProductLocale] = useState(i18n.resolvedLanguage);

    const changeProductLocale = (newValue) => {
        setProductLocale(newValue);
    };

    return (
        <div key={itemCode} className="item__list-name" >
            <ListItemTitleContent localeCode={productLocale} itemCode={itemCode} itemService={itemService} />
            <ListItemWarningIcon itemCode={itemCode} itemService={itemService} />
            <div className="locale__select">
                <LocaleSwitcher localeCode={productLocale} notifyListener={changeProductLocale}/>
            </div>
        </div>
    );
};

export default ListItemTitle;
